import React, { useState } from "react";

export default function ConversationHeader({
  activeContact = {},
  selectedPhone,
  sessionWindow = { active: false, hoursLeft: 0 },
  showContactInfo,
  onToggleContactInfo,
  onOpenTemplateModal,
  onRefreshChat,
  onBackToList,
  showInChatSearch,
  onToggleChatSearch,
  inChatSearch,
  setInChatSearch,
}) {
  const [copied, setCopied] = useState(false);

  const handleCopyPhone = () => {
    if (!selectedPhone) return;
    navigator.clipboard.writeText(`+${selectedPhone}`);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const initial = (activeContact.name || "U")[0]?.toUpperCase();
  const isSubscriber = !!activeContact.subscription_id;

  return (
    <div className="wa-chat-header" role="region" aria-label="Conversation Header">
      {/* Mobile Back Button */}
      {onBackToList && (
        <button
          type="button"
          className="wa-btn-icon wa-btn-back me-1"
          onClick={onBackToList}
          title="Back to chat list"
          aria-label="Back to chat list"
        >
          <i className="bi bi-arrow-left"></i>
        </button>
      )}

      {/* Contact Profile Overview */}
      <div
        className="wa-header-contact-profile"
        onClick={onToggleContactInfo}
        title="Click to view Subscriber Details"
        role="button"
        tabIndex={0}
      >
        <div className={`wa-header-avatar ${isSubscriber ? "is-subscriber" : ""}`}>
          {initial}
          {isSubscriber && (
            <span className="wa-avatar-verified-badge" title="Verified Subscriber">
              <i className="bi bi-patch-check-fill"></i>
            </span>
          )}
        </div>

        <div className="wa-header-contact-details">
          <div className="wa-header-title-row">
            <h5 className="wa-header-name">
              {activeContact.name || `+${selectedPhone}`}
            </h5>
            {isSubscriber && (
              <span className="wa-header-sub-tag">
                {activeContact.subscription_id}
              </span>
            )}
          </div>

          <div className="wa-header-meta-row">
            <span className="wa-header-phone">+{selectedPhone}</span>
            <button
              type="button"
              className="wa-btn-copy-micro"
              onClick={(e) => {
                e.stopPropagation();
                handleCopyPhone();
              }}
              title="Copy Phone Number"
            >
              <i className={`bi ${copied ? "bi-check-lg text-success" : "bi-copy"}`}></i>
            </button>

            <span className="wa-meta-dot">•</span>

            {/* 24-Hour Session Status Indicator */}
            {sessionWindow.active ? (
              <span className="wa-session-pill active" title="Free-form messages allowed">
                <span className="wa-pulse-dot"></span>
                <span>Active ({sessionWindow.hoursLeft}h left)</span>
              </span>
            ) : (
              <span
                className="wa-session-pill expired"
                title="Customer hasn't messaged in >24h. Meta requires an approved template to initiate."
              >
                <i className="bi bi-clock-history me-1"></i>
                <span>Template Required</span>
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Header Context Actions */}
      <div className="wa-header-actions">
        {/* Send Meta Approved Template */}
        <button
          type="button"
          className="wa-btn-template-pill"
          onClick={onOpenTemplateModal}
          title="Send pre-approved Meta Template message"
        >
          <i className="bi bi-lightning-charge-fill me-1"></i>
          <span>Send Template</span>
        </button>

        {/* In-Conversation Search Toggle */}
        <button
          type="button"
          className={`wa-btn-icon wa-btn-inchat-search ${showInChatSearch ? "active" : ""}`}
          onClick={onToggleChatSearch}
          title="Search in this conversation"
          aria-label="Search conversation"
        >
          <i className="bi bi-search"></i>
        </button>

        {/* Reload Chat */}
        <button
          type="button"
          className="wa-btn-icon wa-btn-refresh-chat"
          onClick={onRefreshChat}
          title="Refresh messages"
          aria-label="Refresh"
        >
          <i className="bi bi-arrow-clockwise"></i>
        </button>

        {/* Customer Dossier / Info Toggle */}
        <button
          type="button"
          className={`wa-btn-icon ${showContactInfo ? "active" : ""}`}
          onClick={onToggleContactInfo}
          title={showContactInfo ? "Hide Contact Details" : "Show Contact Details"}
          aria-label="Toggle contact details"
        >
          <i className="bi bi-person-badge"></i>
        </button>
      </div>

      {/* Slide-out In-Chat Search Bar */}
      {showInChatSearch && (
        <div className="wa-inchat-search-tray">
          <i className="bi bi-search text-muted me-2"></i>
          <input
            type="text"
            placeholder="Search words in this chat..."
            value={inChatSearch}
            onChange={(e) => setInChatSearch(e.target.value)}
            autoFocus
          />
          {inChatSearch && (
            <button
              type="button"
              className="wa-btn-search-clear"
              onClick={() => setInChatSearch("")}
            >
              ✕
            </button>
          )}
          <button
            type="button"
            className="wa-btn-search-done"
            onClick={onToggleChatSearch}
          >
            Done
          </button>
        </div>
      )}
    </div>
  );
}
